import { userRequest } from '@/sdk/oauth'
import CareReceiver, { CareReceiverData } from '@/lib/class/CareReceiver'

export function getCareReceivers() {
  return userRequest
    .get('customer/care-receiver')
    .then(response => response.data)
    .catch(() => null)
}

export function createCareReceiver(careReceiver) {
  return userRequest
    .post('customer/care-receiver', preparePostBody(careReceiver))
    .then(response => response.data.care_receiver_id)
    .catch(() => null)
}

export function updateCareReceiver(
  careReceiverId: string,
  careReceiverData: CareReceiver,
) {
  return userRequest
    .post(
      `customer/care-receiver/${careReceiverId}`,
      preparePostBody(careReceiverData),
    )
    .then(response => response.data)
}

export function getCareReceiver(careReceiverId) {
  return userRequest
    .get(`customer/care-receiver/${careReceiverId}`)
    .then(response => response.data)
    .catch(() => null)
}

/**
 * UTILITIES
 */

type PreparePostBodyResponse = Pick<
  CareReceiverData,
  | 'relationship'
  | 'gender'
  | 'name'
  | 'age'
  | 'address'
  | 'description'
  | 'insurance'
  | 'vhp'
> & {
  care_degree: CareReceiverData['careDegree']
} // data fetched from backend uses careDegree while should be care_degree. POST method accepts care_degree.

// @TODO: the class should be responsible of building the API payload
const preparePostBody = ({
  address,
  age,
  careDegree,
  description,
  firstName,
  gender: origGender,
  lastName,
  relationship,
  salutation,
  insurance,
  vhp,
}: CareReceiver): PreparePostBodyResponse => {
  let gender: string

  switch (true) {
    case origGender === 'M':
    case origGender === 'F':
      gender = origGender
      break
    case salutation === 'Frau':
      gender = 'F'
      break
    case salutation === 'Herr':
    default:
      gender = 'M'
      break
  }

  const payload: PreparePostBodyResponse = {
    relationship,
    gender,
    name: {
      first_name: firstName,
      last_name: lastName,
    },
    age: Number(age),
    address: {
      street: address.street,
      house_number: address.streetNumber,
      postal_code: address.postalCode,
      city: address.city,
      additional_information: address.additionalInformation,
    },
    care_degree: careDegree,
    description,
    insurance: {
      insurance_company_id: insurance.insuranceCompanyId,
    },
    vhp: {
      wants_to_use_vhp_budget: vhp.wantsToUseVhpBudget,
    },
  }

  return payload
}
